// extracted by mini-css-extract-plugin
export default {"cls1":"C4UYm2bEtcwRSpBUPfqU","cls2":"foGVaSQySrZtfZFBVbSs C4UYm2bEtcwRSpBUPfqU","bookingAppRedesign":"LyZuVPHy500HwhZquEPU"};